import { render, staticRenderFns } from "./GumroadAnnouncementWarning.vue?vue&type=template&id=4010411e&"
import script from "./GumroadAnnouncementWarning.vue?vue&type=script&lang=js&"
export * from "./GumroadAnnouncementWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports